export { default as AdStatusLabel } from './AdStatusLabel';



// WEBPACK FOOTER //
// ./src/components/AdCard/AdStatusLabel/index.ts